import { AppEntrySubscription } from '@mzc-watchover/terashite-entry-graphql'
import {
  Control,
  FieldErrors,
  FieldValues,
  UseFormRegister
} from 'react-hook-form'

export type FormInputDatas = {
  memberId: string
  applicationDate?: string
  pattern?: string
  couponCode: string
  incompleteCd?: string
  incompleteDetail?: string
  contractDate?: string
  tcId?: string
  statusCd?: string
  lastName: string
  firstName: string
  lastNameKana: string
  firstNameKana: string
  postalCode: string
  phone: string
  email: string
  pref: string
  city: string
  town: string
  place: string
  kateneId?: string
  kateneStatusCode?: string
  barthYear: string
  barthMonth: string
  gender: string
  gas: string
  kateneMailMagazine: boolean
  tokutokuMailMagazine: boolean
  customerNumber: string
  unknownCustomerNumber: boolean
  contractorName: string
  contractorNameKana: string
  contractorPostalCode: string
  contractorPhone: string
  payment: string
  paymentNumber: string
  agree: boolean
  covenant: boolean
  customerId?: string
  cisName?: string
  cisNameKana?: string
  cisZip?: string
  cisPhoneNo?: string
  cisAddress?: string
  cisPaymentTypeCd?: string
  serviceNo?: string
  supplyPoint?: string
  renewableEnergyFlg?: boolean
  highVoltageFlg?: boolean
  contractTypeCd?: string
  masteringCompleteFlg?: boolean
  smartMeterFlg?: boolean
  planTypeCd?: string
  demandStartDate?: string
  contractCapacity?: string
  contractCapacityCd?: string
  notes?: string
  createDate?: string
  updateDate?: string
}
export type FormsProps = {
  register: UseFormRegister<any>
  setters: Record<string, (value: React.SetStateAction<any>) => void>
  formData: FormInputDatas
  errors: FieldErrors<any>
  control: Control<FieldValues, any>
}
export type RequestDatas = {
  sub: string
  companyCode: string
  companyName: string
  departmentName: string
  post: string
  familyNameKanji: string
  familyNameKana: string
  firstNameKanji: string
  firstNameKana: string
  industry: string
  phoneNumber: string
  faxNumber: string
  mailAddress: string
  zipCode: string
  prefecture: string
  address1: string
  address2: string
  address3: string
  questionnair: string
  optionalAnswer: string
  memberId: string
}
export type ContractListDatas = {
  tcid: string
  email: string
  memberId: string
  statusCd: string
  zuoraAccountNo?: string
  applicationDate: string
  couponCode?: string
  incompleteCd?: string
  serviceStartDate?: string
  contractDate?: string
  cancellationDate?: string
  name: string
  nameKana: string
  zip: string
  address: string
  phoneNo: string
  gender?: string
  birth?: string
  customerId?: string
  cisZip?: string
  serviceNo?: string
  cisName?: string
  cisNameKana?: string
  cisAddress?: string
  contractCapacity?: string
  supplyPoint?: string
  cisPhoneNo?: string
  scheduledAbolition?: string
  scheduledAbolitionDate?: string
}
export type CreditCheck = {
  success: boolean
  errorReason?: CreditCheckError
}
export type AlertContext = {
  alertTitle: string
  alertMessage: string
}
export type AlertPropaty =
  | {
      success: AlertContext
      info: AlertContext
      worning: AlertContext
      error: AlertContext
    }
  | undefined

export type MypageOutletContext = {
  memberId: string
  name: string
  autoPayment: string
}
export type VisivleMenuItem = {
  value: string
  text: string
  visible: boolean
}
// export type ContractListFormat = {
//   memberId: string,
//   lastName: string,
//   firstName: string,
//   name: string,
//   lastNameHiragana: string,
//   firstNameHiragana: string,
//   nameHiragana: string,
//   statusCd: string,
//   incompleteCd: string,
//   entryDate: string,
//   contractDate: string,
//   cancellationDate: string,
//   scheduleAbolitationDate: string,
//   referralCd: string,
//   mail: string
// }
export type ContractListFilter = {
  email?: string
  couponCode?: string
  statusCd?: string[]
  name?: string
  nameKana?: string
  incompleteCd?: string[]
  applicationDateFrom?: string
  applicationDateTo?: string
  contractDateFrom?: string
  contractDateTo?: string
  cancellationDateFrom?: string
  cancellationDateTo?: string
  scheduledAbolitionDateFrom?: string
  scheduledAbolitionDateTo?: string
}
export type RegistKateneDatas = {
  api_token: string
  tcid_sub: string
  mail_address: string
  last_name: string
  first_name: string
  last_name_kana: string
  first_name_kana: string
  post_code: string
  administrative_div: string
  deme_town_village: string
  house_no: string
  apartment_name: string
  mail_magazine_campaign: boolean
  mail_magazine_point: boolean
  sex: string
  birthday: string
  extra_info: {
    gas_type: string
  }
  send_mail: boolean
}
export type PaymentRegistDatas = {
  name: string
  autoPay: false
  batch: 'Batch3'
  billCycleDay: 1
  currency: 'JPY'
  paymentGateway: 'GMO-PG（テラシテ）'
  communicationProfileId: 'xxxxxxxxxxxxxxxxxxxxxxxxx'
  billToContact: PaymentContractDatas
  soldToContact: PaymentContractDatas
  taxInfo: {
    exemptStatus: 'No'
  }
  tcid__c: string
  memberID__c: string
  serviceName__c: 'テラシテ'
}
export type PaymentContractDatas = {
  firstName: string
  lastName: string
  otherPhone: string
  otherPhoneType: 'Other'
  personalEmail: string
  zipCode: string
  country: 'Japan'
  state: string
  city: string
  address1: string
  address2?: string
}
export type UserOutletContext = {
  memberId?: string
  subscription?: AppEntrySubscription
  paymentSubscriptions?: string[]
}
export const ContractTableLabel = {
  name: '契約者（漢字）',
  nameKana: '契約者（かな）',
  statusCd: '契約ステータス',
  incompleteCd: '申込不備内容',
  applicationDate: '申込日',
  contractDate: '契約日',
  scheduledAbolitionDate: '廃止予定日',
  cancellationDate: '解約（予定）日',
  couponCode: '紹介コード',
  email: 'TCIDメールアドレス'
}
export const ContractListLabel = {
  tcid: 'TCID識別子',
  email: 'メールアドレス',
  memberId: '会員ID',
  statusCd: '契約ステータス',
  zuoraAccountNo: 'ZuoraアカウントNo',
  applicationDate: '申込日',
  couponCode: '紹介コード',
  incompleteCd: '申込不備内容',
  contractDate: '契約日',
  cancellationDate: '解約（予定）日',
  name: '契約者氏名（漢字）',
  nameKana: '契約者氏名（かな）',
  zip: '契約者郵便番号',
  address: '契約者住所',
  phoneNo: '契約者電話番号',
  kateneCd: '申込時カテエネ登録状態コード',
  gender: '性別',
  birth: '生年月',
  customerId: 'お客さま番号',
  cisZip: '需要場所郵便番号',
  serviceNo: 'サービス契約番号',
  cisName: 'CIS契約名義（漢字）',
  cisNameKana: 'CIS需要場所郵便番号',
  cisAddress: 'CIS需要場所住所',
  contractCapacity: '契約容量',
  supplyPoint: '供給地点特定番号',
  cisPhoneNo: 'CIS電話番号',
  selfCheckResult: '本人確認結果',
  scheduledAbolition: '廃止速報情報有無',
  scheduledAbolitionDate: '廃止予定日'
}
export enum RegistrationStatus {
  entry = 'entry',
  subscription = 'subscription'
}
export enum EnumPaymentGmoPgStatus {
  Draft = 'Draft',
  Processing = 'Processing',
  Processed = 'Processed',
  Error = 'Error',
  Voided = 'Voided',
  Canceled = 'Canceled',
  Pending = 'Pending',
  Completed = 'Completed'
}
export enum CreditCheckError {
  internalError = 'internalError',
  badRequest = 'badRequest'
}
export enum SubscriptionStatus {
  waitingForInput = 'waitingForInput',
  confirmingInput = 'confirmingInput',
  confirmingCustomerNumber = 'confirmingCustomerNumber',
  confirmingContract = 'confirmingContract',
  reconfirmationContract = 'reconfirmationContract',
  discarded = 'discarded',
  inProgress = 'inProgress',
  suspension = 'suspension',
  cancellation = 'cancellation',
  consentFormPrepared = 'consentFormPrepared',
  consentFormRecieved = 'consentFormRecieved',
  denkankyoConsentFailed = 'denkankyoConsentFailed'
}
